import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authFetch } from '../../api';

export const AuthGuard = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      // Exclude public portal routes from authentication
      if (location.pathname.startsWith('/portal/')) {
        setLoading(false);
        return;
      }
      
      const res = await authFetch('get-session');
      if (res?.data?.user) {
        localStorage.setItem('user_id', res.data.user.id);
        setLoading(false);
      } else {
        localStorage.removeItem('user_id');
        navigate('/login');
      }
    };
    checkAuth();
  }, [navigate, location]);

  if (loading) {
    return (
      <div className="h-screen bg-slate-950 flex flex-col items-center justify-center">
        <div className="w-12 h-12 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-teal-500 font-bold text-sm tracking-widest uppercase">Authenticating...</p>
      </div>
    );
  }
  
  return children;
};